import { get } from 'lodash';
import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';

import { Breadcrumbs, Typography } from '@mui/material';
import { ART_DES_ANTRAGS } from 'src/lib/constants/constant';
import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
import { enumT } from '../../../../utils/helper';
const P = Schema.attributes;

const BreadCrumbAntrag: FC<{}> = () => {
	const { application } = useApplication();
	const isFormantrag = get(application, P.Allgemein_Art_Des_Antrags.path, '') === ART_DES_ANTRAGS.Formantrag;
	const formular = isFormantrag ? get(application, P.Allgemein_Art_Des_Antrags.path, '') : get(application, P.Allgemein_Typ.path, '');
	return (
		<>
			<Breadcrumbs separator='›' aria-label='breadcrumb' sx={{ maxWidth: '81.875rem' }}>
				<Typography color='secondary'>Mein Bereich</Typography>
				<Typography color='secondary'>Förderungen</Typography>
				<Typography color='secondary'>{enumT(formular)}</Typography>
				<Typography color='primary'>{get(application, P.Allgemein_Projekttitel.path, '*')}</Typography>
			</Breadcrumbs>
		</>
	);
};

export default BreadCrumbAntrag;
